// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"193c605b","455":"b6c94890","517":"0b500779","977":"8339f93d"}[chunkId] + ".chunk.js";
};